export enum ValidationStatus {
  InProgress = 1,
  Complete = 2,
  CompleteWithOverride = 3,
}
